/* Modulo: Collection Peek — hover cover swap.
 *
 * The swap images are NOT in the markup. Each thumb carries data-cpk-src and the <img> is
 * created on the FIRST hover only, then cached for the life of the page. A card with three
 * previews would otherwise ship three extra full-size images, and a six-card row eighteen —
 * straight into the LCP budget, for an interaction most visitors never trigger.
 *
 * Binding is gated on (hover: hover) and (pointer: fine). Phones have no hover, and hijacking a
 * thumb tap would break the card's single link, so touch gets the static card.
 */
(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  // An identical <script src> still executes once per tag, so two instances of this section on
  // one page would otherwise bind a duplicate document-level listener.
  if (window.moduloCpkReady) return;
  window.moduloCpkReady = true;

  var mm = window.matchMedia;
  var HOVER = mm ? mm('(hover: hover) and (pointer: fine)').matches : false;

  function initCard(card) {
    var frame = card.querySelector('.modulo-cpk__frame');
    var live = card.querySelector('.modulo-cpk__caption-live');
    var thumbs = card.querySelectorAll('[data-cpk-thumb]');
    if (!frame || !thumbs.length) return;

    var cache = {};
    var i;

    function clearActive() {
      for (var k in cache) {
        if (Object.prototype.hasOwnProperty.call(cache, k)) cache[k].classList.remove('is-on');
      }
    }

    function show(thumb) {
      var src = thumb.getAttribute('data-cpk-src');
      if (!src) return;

      var img = cache[src];
      if (!img) {
        img = document.createElement('img');
        img.className = 'modulo-cpk__swap';
        img.alt = '';
        img.setAttribute('aria-hidden', 'true');
        img.decoding = 'async';
        img.src = src;
        cache[src] = img;
        frame.appendChild(img);
        // let it land before flipping opacity, or the fade has nothing to transition from
        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () { img.classList.add('is-on'); });
          });
        } else {
          img.classList.add('is-on');
        }
      } else {
        img.classList.add('is-on');
      }

      for (var k in cache) {
        if (Object.prototype.hasOwnProperty.call(cache, k) && k !== src) cache[k].classList.remove('is-on');
      }

      if (live) {
        // built with textContent / createElement, never innerHTML
        live.textContent = thumb.getAttribute('data-cpk-title') || '';
        var price = thumb.getAttribute('data-cpk-price');
        if (price) {
          live.appendChild(document.createTextNode(' '));
          var span = document.createElement('span');
          span.className = 'modulo-cpk__price';
          span.textContent = price;
          live.appendChild(span);
        }
      }

      card.classList.add('is-peeking');
    }

    function reset() {
      clearActive();
      card.classList.remove('is-peeking');
    }

    for (i = 0; i < thumbs.length; i++) {
      (function (t) {
        t.addEventListener('pointerenter', function () { show(t); });
      })(thumbs[i]);
    }
    card.addEventListener('pointerleave', reset);
  }

  function initSection(section) {
    if (!section || section.hasAttribute('data-cpk-ready')) return;
    section.setAttribute('data-cpk-ready', '');
    if (!HOVER) return; // still marked ready — nothing to bind on touch
    var cards = section.querySelectorAll('.modulo-cpk__card');
    for (var i = 0; i < cards.length; i++) initCard(cards[i]);
  }

  function boot(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll('[data-modulo-cpk]');
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
    if (root && root.matches && root.matches('[data-modulo-cpk]')) initSection(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // theme editor: re-init when this section is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    boot(e && e.target ? e.target : document);
  });
})();
